<template>
  <div class="content-warpper">
    <div class="warpper-title flex align-center justify-between">
      <div>
        <i class="iconfont iconshixi"></i>
        职位推送
      </div>

      <el-button
          size="medium"
          type="primary"
          @click="pushChiose"
      >立即推送
      </el-button>
    </div>
    <div class="padding-sm">
      <h3 class="title">岗位选择</h3>
      <el-transfer
          v-model="practice"
          :titles="['可选岗位', '已选岗位']"
          :props="{key: 'sx_id',label: 'desc'}"
          :data="practiceList">
      </el-transfer>
      <h3 class="title margin-top-sm">班级选择</h3>
      <el-transfer
          v-model="classs"
          :titles="['可选班级', '已选班级']"
          :props="{key: 'class_id',label: 'desc'}"
          :data="classList">
      </el-transfer>
    </div>
  </div>
</template>

<script>


import {stationSchoolList,classList,setPush} from "@/api/fuse";

export default {
  name: "practicePush",
  data() {
    return {
      practiceList: [],
      practice: [],
      classList: [],
      classs: []
    }
  },
  created() {
    this.$emit(
        "setIndex",
        '/fuse/practiceBase',
        "当前位置：实习岗位 > 职位推送",
        true
    );
    this.getList()
  },
  methods: {
    async getList() {
      let _list = await stationSchoolList(0, '', '', '',);
      _list.data.map(item => {
        item.desc = item.org_name + '-' + item.sx_name
      })
      this.practiceList = _list.data;

      let _list2 = await classList('',0,'')
      _list2.data.map(item=>{
        item.desc =item.year + '-' + item.class_name
      })
      this.classList = _list2.data;


    },
    async pushChiose() {
      if(this.practice.length === 0) return this.$message.error('请选择要推送的实习岗位')
      if(this.classs.length === 0) return this.$message.error('请选择要接收的班级')
      let _state = await setPush(this.practice.join(','),this.classs.join(','))
      this.$message.success(_state.msg)
      this.getList()
      this.practice = []
      this.classs = []
    },
  }
}
</script>

<style scoped lang="scss">
.title {
  line-height: 40px;
  font-size: 16px;
  color: #009688;
}
</style>